import { render, staticRenderFns } from "./StudentFileQuery.vue?vue&type=template&id=6ef6b4a8"
import script from "./StudentFileQuery.vue?vue&type=script&lang=js"
export * from "./StudentFileQuery.vue?vue&type=script&lang=js"
import style0 from "./StudentFileQuery.vue?vue&type=style&index=0&id=6ef6b4a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports